<template>
  <modal-structure
    :has-cancel-button="false"
    :affirmative-handler="handleAffirmative"
    :negative-handler="handleNegative"
  >
    <template v-slot:header />
    <template v-slot:content>
      <h1>{{ $t('modals.form_submission.message') }}</h1>
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import ModalStructure from './ModalStructure'
export default {

  name: 'FormSubmittedModal',
  components: {
    ModalStructure
  },

  methods: {
    handleAffirmative () {
      this.$root.$emit('close::custom::modal')
    },
    handleNegative () {
      // console.log('you answered in the negative:')
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    text-align: center
  }
</style>
